/*@ngInject*/
const PopupNotificationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

        this.loadPopupNotificationActions = function () {
            var url = '/rest/Actions',
                config = {
                    params: {
                        uri: 'com.firstbest.underwriting.notification.NotificationPopupTemplate'
                    }
                };

        return this.get(url, config);
    };

        this.loadPopupNotification = function (requestParams) {
            var url = '/rest/NotificationPopupTemplate',
                config = {
                    params: {
                        sortBy: requestParams.key,
                        sortDirection: requestParams.sortType,
                        startIndex: requestParams.startIndex,
                        numberOfRows: requestParams.pageSize,
                        searchString:requestParams.searchString
                    }
                };
            return this.get(url,config);
        };

};

angular.module('ums.configuration')
    .service('popupNotificationRepository', PopupNotificationRepository);
